"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserProvider = void 0;
const core_1 = require("@qubic-js/core");
const detect_iab_1 = require("@qubic-connect/detect-iab");
const cacheMiddleware_1 = __importDefault(require("./middlewares/cacheMiddleware"));
const IFrame_1 = __importDefault(require("./middlewares/IFrame"));
const PopupWindow_1 = __importDefault(require("./middlewares/PopupWindow"));
const persistData_1 = require("./utils/persistData");
const isInQubicDappBrowser_1 = require("./utils/isInQubicDappBrowser");
let isInitialized = false;
class BrowserProvider extends core_1.BaseProvider {
    constructor(options) {
        const { apiKey, apiSecret, chainId = core_1.Network.MAINNET, infuraProjectId, enableIframe = false, walletUrl = core_1.WALLET_URL, iabRedirectUrl, shouldAlwaysShowCopyUI, disableFastSignup, disableIabWarning = false, disableOpenExternalBrowserWhenLineIab = false, enablePersist = false, } = options || {};
        const apiConfig = {
            apiKey,
            apiSecret,
            chainId,
        };
        const { hide, bridge, createPrepareBridgeMiddleware, setSignInProvider: originSetSignInProvider, removeSignInProvider: originRemoveSignInProvider, } = enableIframe
            ? new IFrame_1.default(walletUrl, apiConfig, disableFastSignup)
            : new PopupWindow_1.default(walletUrl, apiConfig, disableFastSignup);
        if (!disableOpenExternalBrowserWhenLineIab) {
            detect_iab_1.openExternalBrowserWhenLineIab();
        }
        if (!disableIabWarning && !isInQubicDappBrowser_1.isInQubicDappBrowser) {
            detect_iab_1.showBlockerWhenIab({
                redirectUrl: iabRedirectUrl,
                shouldAlwaysShowCopyUI,
            });
        }
        super({
            infuraProjectId,
            network: chainId,
            bridge,
            middlewares: [cacheMiddleware_1.default(bridge, enablePersist), createPrepareBridgeMiddleware()],
        });
        this.setSignInProvider = originSetSignInProvider;
        this.removeSignInProvider = originRemoveSignInProvider;
        if (isInitialized) {
            throw Error(`You can only new BrowserProvider() one time`);
        }
        isInitialized = true;
        this.hide = () => hide();
        // when dapp browser open dapp which use qubic-sdk
        // it will use window.ethereum as default provider
        if (isInQubicDappBrowser_1.isInQubicDappBrowser) {
            // ignore all these methods
            isInQubicDappBrowser_1.globalEthereum.hide = () => null;
            isInQubicDappBrowser_1.globalEthereum.setSignInProvider = () => null;
            isInQubicDappBrowser_1.globalEthereum.removeSignInProvider = () => null;
            return isInQubicDappBrowser_1.globalEthereum;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    clearPersistedData() {
        persistData_1.clearPersistedData();
    }
}
exports.BrowserProvider = BrowserProvider;
exports.default = BrowserProvider;
